/**
 * Created by mac on 7/26/18
 */

MissionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, options) {
        this.mission = mission;

        options = options || {};
        this.options = options;

        this.name = options.name || `${mission.getName()}_missionwindow`;
        this.bundleName = options.bundleName || "mission_window";

        this._super({
            name: options.name,
            content: new TropicalMissionView(this),
            noBackground: true,
            closeButton: false,
            styles: cleverapps.styles.MissionWindow[cleverapps.resolution.isVertical() ? "verticalWindow" : "window"],
            notCloseByTouchInShadow: true,
            offerWindowButton: options.offerWindowButton,
            openSound: options.openSound
        });

        this.mission.updateCompetitionResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    onShow: function () {
        this._super();

        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();

        this._super();
    },

    listBundles: function () {
        return ["mission_window"];
    }
});

cleverapps.styles.MissionWindow = {
    verticalWindow: {
        windowShowUpAnimation: undefined,
        Background: {
            padding: {
                x: -10
            }
        }
    },

    window: {
        windowShowUpAnimation: undefined
    }
};

MissionWindow.TableRowIcons = [
    {
        type: Mission.TYPE_EXPEDITION_FEAST, icon: bundles.tablerow_icons.frames.feast_energy
    },
    {
        type: Mission.TYPE_LIVESFEAST, icon: bundles.tablerow_icons.frames.feast_energy, animation: bundles.tablerow_icons.jsons.feast_energy_animation_json, effect: "feast.row.fly"
    },
    {
        type: Mission.TYPE_SOFTFEAST, icon: bundles.tablerow_icons.frames.feast_coin, animation: bundles.tablerow_icons.jsons.feast_coin_animation_json, effect: "feast.row.fly"
    },
    {
        type: Mission.TYPE_KRAKENFEAST, icon: bundles.tablerow_icons.frames.feast_tentacle, animation: bundles.tablerow_icons.jsons.feast_tentacle_animation_json, effect: "feast.row.fly"
    }
];

MissionWindow.GetTableRowIcon = function (type) {
    const childType = Mission.GetMissionType(type);

    const tableRowIcon = MissionWindow.TableRowIcons.find(({ type }) => type === childType) || {};
    const img = cleverapps.skins.getSlot("missionTableRowIcon", { type });
    if (img) {
        tableRowIcon.icon = img;
    }
    return tableRowIcon;
};